import { css } from '@emotion/react';

import { breakpoints, typography2 } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

export type EnrollButtonSize = 'small' | 'large';

const styles = {
  buttonWrapper: (_: Theme, size?: EnrollButtonSize) => css`
    // Important styles are to override ApiButton.
    & > button,
    & > a {
      background: var(--cds-color-blue-800) !important;
      box-shadow: inset 0 0 0 1px var(--cds-color-blue-800);
      border-radius: 4px;
      width: 100%;
      ${typography2.bodyPrimary}
      color: var(--cds-color-neutral-primary-invert) !important;
      font-weight: 700;
      padding: ${size === 'small' ? 'var(--cds-spacing-100)' : 'var(--cds-spacing-150)'};
      ${
        size === 'small' &&
        `
  min-height: 36px;
  font-size: 0.875rem;
  line-height: 1.25rem;
`
      }
      transition: none;

      &:hover {
        background: var(--cds-color-blue-800) !important;
      }
    }

    & > button[disabled] {
      background: var(--cds-color-grey-200) !important;
      box-shadow: none;
      border: none;

      &:hover {
        background: var(--cds-color-grey-200) !important;
      }
    }

    .cui-iconWrapper {
      display: none;
    }

    .rc-StartDateButton {
      line-height: 1.2rem;

      > div {
        padding-top: 0;
        font-size: 0.8rem;
      }
    }
  `,
};

export const sharedButtonStyles = {
  button: css`
    ${breakpoints.down('sm')} {
      display: block;
      width: 100%;
    }

    button {
      border-radius: 4px;
      ${typography2.actionPrimary};
      font-weight: 700;

      &:not([disabled]) {
        background: var(--cds-color-interactive-primary);

        &:hover {
          background: var(--cds-color-interactive-primary-hover);
          border-color: var(--cds-color-interactive-primary-hover);
        }
      }

      ${breakpoints.down('sm')} {
        width: 100%;
      }
    }
  `,
};
export default styles;
